import * as React from "react";
import { JSX } from "react/jsx-runtime";

const SVGComponent = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={14}
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 1.16669C3.11161 1.16669 0.192234 6.49019 0.070875 6.71652C-0.023625 6.89283 -0.023625 7.10706 0.070875 7.28337C0.192234 7.5097 3.11161 12.8333 9 12.8333C14.8884 12.8333 17.8078 7.5097 17.9291 7.28337C18.0236 7.10706 18.0236 6.89283 17.9291 6.71652C17.8078 6.49019 14.8884 1.16669 9 1.16669ZM9 11.6667C4.50633 11.6667 1.89098 8.05366 1.22442 7.00089C1.89098 5.94812 4.50633 2.33336 9 2.33336C13.4937 2.33336 16.109 5.94637 16.7757 6.99914C16.109 8.05191 13.4937 11.6667 9 11.6667ZM9 3.50002C7.06897 3.50002 5.555 5.07006 5.555 7.00002C5.555 8.92997 7.06897 10.5 9 10.5C10.931 10.5 12.445 8.92997 12.445 7.00002C12.445 5.07006 10.931 3.50002 9 3.50002ZM9 9.33336C7.71269 9.33336 6.66667 8.28734 6.66667 7.00002C6.66667 5.7127 7.71269 4.66669 9 4.66669C10.2873 4.66669 11.3333 5.7127 11.3333 7.00002C11.3333 8.28734 10.2873 9.33336 9 9.33336Z"
      fill="#1F2A37"
    />
  </svg>
);

export default SVGComponent;
